import { render, staticRenderFns } from "./MembershipPolicy.vue?vue&type=template&id=32673a94&"
import script from "./MembershipPolicy.vue?vue&type=script&lang=js&"
export * from "./MembershipPolicy.vue?vue&type=script&lang=js&"
import style0 from "./MembershipPolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports